import React from "react";

export default function BooleanStringIco() {
  return (
    <svg
      width="18"
      height="9"
      viewBox="0 0 18 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.125 8.75C12.2597 8.75 11.4138 8.49341 10.6944 8.01268C9.97492 7.53195 9.41416 6.84867 9.08303 6.04924C8.7519 5.24981 8.66526 4.37015 8.83407 3.52148C9.00288 2.67281 9.41956 1.89326 10.0314 1.28141C10.6433 0.669555 11.4228 0.252877 12.2715 0.0840664C13.1201 -0.084744 13.9998 0.00189561 14.7992 0.333029C15.5987 0.664162 16.282 1.22492 16.7627 1.94438C17.2434 2.66385 17.5 3.50971 17.5 4.375C17.4987 5.53493 17.0374 6.64698 16.2172 7.46717C15.397 8.28736 14.2849 8.74871 13.125 8.75ZM13.125 1.25C12.5069 1.25 11.9027 1.43328 11.3888 1.77666C10.8749 2.12004 10.4744 2.6081 10.2379 3.17912C10.0014 3.75014 9.93947 4.37847 10.06 4.98466C10.1806 5.59085 10.4783 6.14767 10.9153 6.58471C11.3523 7.02175 11.9092 7.31938 12.5153 7.43996C13.1215 7.56053 13.7499 7.49865 14.3209 7.26213C14.8919 7.0256 15.38 6.62506 15.7233 6.11116C16.0667 5.59726 16.25 4.99307 16.25 4.375C16.2491 3.54648 15.9196 2.75215 15.3337 2.1663C14.7479 1.58044 13.9535 1.25091 13.125 1.25Z"
        fill="#7F56D9"
      />
      <path
        d="M4.375 8.75C6.79125 8.75 8.75 6.79125 8.75 4.375C8.75 1.95875 6.79125 0 4.375 0C1.95875 0 0 1.95875 0 4.375C0 6.79125 1.95875 8.75 4.375 8.75Z"
        fill="#7F56D9"
      />
    </svg>
  );
}
